/**
 * Public marketing-site facts. Everything a lawyer, a designer, or a launch
 * checklist might need to change lives here rather than inside a page.
 */

export const SITE = {
  name: 'Shoutt',
  tagline: 'Ask your campus. Anything.',
  intro:
    'Shoutt is a campus-only app for verified college students. Rent out what you are not using and earn, or post a Shoutt and a verified student nearby picks it up.',
  url: 'https://shoutt.live',
} as const;

export const CONTACT = {
  email: 'hello@shoutt.live',
  foundersEmail: 'founders@shoutt.live',
  phone: '+91 90792 29368',
  /** Dialable form of `phone` — tel: links must carry no spaces. */
  phoneHref: 'tel:+919079229368',
  instagramHandle: '@shoutt.live',
  instagramUrl: 'https://instagram.com/shoutt.live',
  grievanceEmail: 'hello@shoutt.live',
  /** Play's CSAE point of contact, and the address declared in Play Console. Currently
   *  the developer account address; point it at a dedicated monitored alias if one is
   *  ever created — the published standards page reads this, so it updates with it. */
  childSafetyEmail: 'founders@shoutt.live',
} as const;

/** Live store listings. Changing a URL here updates every badge on the site. */
export const STORE_LINKS = {
  ios: 'https://apps.apple.com/in/app/shoutt-ask-your-campus/id6805906896',
  android: 'https://play.google.com/store/apps/details?id=com.shoutt',
} as const;

/** Registered entity behind the Shoutt brand. Rendered verbatim in the legal pages. */
export const LEGAL_ENTITY = {
  name: 'Pear Circle Private Limited',
  address:
    'BL-102, Lotus Apartment, Swastik Soc., Sanala Road, Morbi MDG, Morbi, Rajkot – 363641, Gujarat',
  jurisdiction: 'Ahmedabad, Gujarat',
  grievanceOfficer: 'Ritesh Phophalia',
  grievanceOfficerDesignation: 'Founder',
} as const;

/** Shown as "Last updated" on the legal pages. */
export const LEGAL_LAST_UPDATED = '24 August 2026';
